import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert,
} from '@mui/material';
import { PersonAdd as PersonAddIcon, Login as LoginIcon } from '@mui/icons-material';

interface AccountNotFoundDialogProps {
  open: boolean;
  onClose: () => void;
  onCreateAccount: () => void;
  onTryAgain: () => void;
}

const AccountNotFoundDialog: React.FC<AccountNotFoundDialogProps> = ({
  open,
  onClose,
  onCreateAccount,
  onTryAgain,
}) => {
  return (
    <Dialog 
      open={open} 
      maxWidth="sm" 
      fullWidth
      onClose={onClose}
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <PersonAddIcon color="primary" />
          <Typography variant="h6" component="div">
            Account Not Found
          </Typography>
        </Box>
      </DialogTitle>
      
      <DialogContent>
        <Alert severity="info" sx={{ mb: 2 }}>
          <Typography variant="body1" gutterBottom>
            <strong>No account found with that email address.</strong>
          </Typography>
          <Typography variant="body2">
            It looks like you haven't created an account yet. Would you like to create one now?
          </Typography>
        </Alert>
        
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          Creating an account is quick and easy - just choose your role (coach or athlete) and you'll be ready to start tracking your running activities!
        </Typography>
      </DialogContent>
      
      <DialogActions sx={{ p: 3, pt: 1 }}>
        <Button
          onClick={onTryAgain}
          variant="outlined"
          startIcon={<LoginIcon />}
        >
          Try Again
        </Button>
        <Button
          onClick={onCreateAccount}
          variant="contained"
          startIcon={<PersonAddIcon />}
          sx={{ ml: 1 }}
        >
          Create Account
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AccountNotFoundDialog;
